const actions = {
  SET_STATE: "sponsors/SET_STATE",
  GET_SPONSORS: "sponsors/GET_SPONSORS",
  DELETE_SPONSORS: "sponsors/DELETE_SPONSORS",
  EDIT_SPONSOR: "sponsors/EDIT_SPONSOR",
  CREATE_SPONSOR: "sponsors/CREATE_SPONSOR"
};

export default actions;
